import {Loader} from '@orbit-ui/components/loader';
import {createFileRoute, useNavigate} from '@tanstack/react-router';
import {useAuth} from '@workos-inc/authkit-react';
import {useEffect} from 'react';

export const Route = createFileRoute('/_public/auth/callback')({
  component: CallbackComponent,
  // Remove the immediate redirect in beforeLoad
});

function CallbackComponent() {
  const {isLoading, user} = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading) return;

    if (user) {
      // Only redirect to a protected route once user
      navigate({to: '/clusters/overview'});
    }
  }, [isLoading, user, navigate]);

  return <Loader />; // teri auth spinne
}
